module.exports = __webpack_public_path__ + "img/logo.49b93444.png";